import RefreshIcon from '@mui/icons-material/Refresh'
import { Card, CardContent, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { useSelector } from 'react-redux'

import TabHeader from '@/app/component/atom/tab-header'
import CustomTooltip from '@/app/component/atom/tooltip'
import { useGetReceipts } from '@/app/module/payments/hooks/use-get-receipts'
import { selectOrgId } from '@/app/module/user/store/selectors'

import Receipts from './receipts'

const PurchaseReceipts: React.FC = () => {
  const orgId = useSelector(selectOrgId)
  const { data, isFetching, refetch } = useGetReceipts()

  return (
    <Container>
      <TabHeader
        action={
          <CustomTooltip title="Reload receipts">
            <IconButton disabled={isFetching} onClick={() => refetch()}>
              <RefreshIcon />
            </IconButton>
          </CustomTooltip>
        }
        title="Purchase receipts"
      />
      <Content>
        <Receipts isFetching={isFetching} orgId={orgId} receipts={data || []} />
      </Content>
    </Container>
  )
}

const Container = styled(Card)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
})

const Content = styled(CardContent)({
  flex: 1,
  overflow: 'hidden',
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  '&:last-child': {
    paddingBottom: 0,
  },
})

export default PurchaseReceipts
